import { $translate } from '@/utils/i18n';
export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        selectBtn: false,
        clickState: true,
        leftOperation: true,
        columns: [
            {
                label: $translate('lang.E3202103180002', { defaultText: '字典编码' }),
                align: 'center',
                prop: 'code',
                filter: true,
                require: true,
                sort: true
            },
            {
                label: $translate('lang.E3202103180003', { defaultText: '字典名称' }),
                align: 'center',
                prop: 'name',
                filter: true,
                require: true,
                sort: true
            },
            {
                label: $translate('lang.E3202101260002', { defaultText: '租户' }),
                align: 'center',
                prop: 'tenantCode',
                filter: true,
                require: true,
                sort: true
            },
            {
                label: $translate('lang.E3202101250010', { defaultText: '状态' }),
                align: 'center',
                prop: 'enableFlagDict',
                filter: true,
                require: true,
                sort: true,
                type: 'dictionary'
            }
        ],
        action: [
            {
                type: 'text',
                label: $translate('lang.E3202102260009', { defaultText: '编辑' }),
                event: 'edit',
                size: 'small'
            },
            {
                type: 'text',
                label: $translate('lang.E3202102230004', { defaultText: '删除' }),
                event: 'delete',
                size: 'small'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
